module.exports = __webpack_public_path__ + "img/failure-rvs.56ef9326.png";